import { createAction, props } from '@ngrx/store';
import { Ticket } from 'src/app/shared/models/ticket/Ticket';
import { TicketFilter } from 'src/app/shared/models/ticket-filter/TicketFilter';
import { ApiPagingConfig } from 'src/app/shared/models/paging/ApiPagingConfig';
import { TICKET_LIST_ENTRY_POINT } from 'src/constants/query-params';
import { IInteractionItem } from 'src/app/shared/models/interaction/IInteraction';
import { IResponseMessage } from 'src/app/shared/models/response-message/IResponseMessage';
import { TicketStatus } from 'src/app/shared/models/ticket-status/TicketStatus';
import { IFile } from 'src/app/shared/models/file/IFile';

export const TicketActionTypes = {
  SEARCH: '[TICKET] Search',
  CANCEL_SEARCH: '[TICKET] Cancel Search',
  SEARCH_SUCCESS: '[TICKET] Search success',
  CLEAR_TICKETS: '[TICKET] clear list',
  CLEAR_TICKET: '[TICKET] clear ticket',
  GET_UPDATES_AVAILABLE: '[TICKET] get updates available',
  GET_UPDATES_AVAILABLE_SUCCESS: '[TICKET] get updates available success',
  GET_TICKET: '[TICKET] Get ticket',
  GET_TICKET_STATUSES: '[TICKET] Get ticket statuses',
  GET_TICKET_PRIORITYS: '[TICKET] Get ticket prioritys',
  GET_TICKET_LIST_ENTRY_POINT: '[TICKET] Get ticket list entry point',
  GET_TICKET_LIST_ENTRY_POINT_SUCCESS: '[TICKET] Get ticket list entry point success',
  GET_TICKET_LIST_ENTRY_POINT_ERROR: '[TICKET] Get ticket list entry point error',
  GET_TICKET_SUCCESS: '[TICKET] Get ticket success',
  GET_TICKET_ERROR: '[TICKET] Get ticket error',
  SEARCH_CHANGE_RECORDS_SUCCESS: '[TICKET] Search change records success',
  CLEAR_CHANGE_RECORDS_TICKETS: '[TICKET] Clear change records tickets',
  CLEAR_CHANGE_RECORDS_TICKET: '[TICKET] Clear change records ticket',
  SEARCH_CHANGE_RECORDS_ERROR: '[TICKET] Search change records error',
  GET_CHANGE_RECORDS_TICKET: '[TICKET] Get change records ticket',
  GET_CHANGE_RECORDS_TICKET_SUCCESS: '[TICKET] Get change records ticket success',
  GET_CHANGE_RECORDS_TICKET_ASSESSMENT: '[TICKET] Get change records ticket assessment',
  GET_CHANGE_RECORDS_TICKET_ASSESSMENT_SUCCESS: '[TICKET] Get change records ticket assessment success',
  GET_CHANGE_RECORDS_TICKET_PLANNING: '[TICKET] Get change records ticket planning',
  GET_CHANGE_RECORDS_TICKET_PLANNING_SUCCESS: '[TICKET] Get change records ticket planning success',
  GET_CHANGE_RECORDS_TICKET_SCHEDULING: '[TICKET] Get change records ticket scheduling',
  GET_CHANGE_RECORDS_TICKET_SCHEDULING_SUCCESS: '[TICKET] Get change records ticket scheduling success',
  GET_CHANGE_RECORDS_TICKET_AFFECTED: '[TICKET] Get change records ticket affected',
  GET_CHANGE_RECORDS_TICKET_AFFECTED_SUCCESS: '[TICKET] Get change records ticket affected success',
  GET_CHANGE_RECORDS_TICKET_IMPLEMENTATION: '[TICKET] Get change records ticket implementation',
  GET_CHANGE_RECORDS_TICKET_IMPLEMENTATION_SUCCESS: '[TICKET] Get change records ticket implementation success',
  GET_CHANGE_RECORDS_TICKET_APPROVALS: '[TICKET] Get change records ticket approvals',
  GET_CHANGE_RECORDS_TICKET_APPROVALS_SUCCESS: '[TICKET] Get change records ticket approvals success',
  GET_CHANGE_TASKS_FOR_CHANGE_RECORDS_TICKET: '[TICKET] Get change tasks for change records ticket',
  GET_CHANGE_TASKS_FOR_CHANGE_RECORDS_TICKET_SUCCESS: '[TICKET] Get change tasks for change records ticket success',
  GET_TICKET_APPROVALS_SUCCESS: '[TICKET] get ticket approvals success',
  GET_APPROVALS: '[TICKET] Get approvals',
  GET_TICKET_APPROVALS: '[TICKET] Get ticket approvals',
  GET_SERVICE_REQUESTS_TASKS: '[TICKET] Get sr tasks',
  GET_APPROVALS_SUCCESS: '[TICKET] Get approvals success',
  GET_TICKET_INTERACTIONS: '[TICKET] Get ticket interactions',
  GET_TICKET_INTERACTIONS_SUCCESS: '[TICKET] Get ticket interactions success',
  CLEAR_INTERACTIONS: '[TICKET] Clear interactions',
  CLEAR_APPROVALS: '[TICKET] Clear approvals',
  POST_TICKET_INTERACTION: '[TICKET] Post ticket interaction',
  POST_TICKET_INTERACTION_SUCCESS: '[TICKET] Post ticket interaction success',
  POST_TICKET_INTERACTION_ERROR: '[TICKET] Post ticket interaction error',
  GET_ORDER_ITEMS: '[TICKET] Get order items',
  SET_ORDER_ITEMS: '[TICKET] Set order items',
  ORDERS_LOADING_STATUS: '[TICKET] Set orders loading status',

  // RFC
  SEARCH_REQUEST_FOR_CHANGES_SUCCESS: '[TICKET] Search request for changes success',
  CLEAR_REQUEST_FOR_CHANGES_TICKETS: '[TICKET] Clear request for changes tickets',
  CLEAR_REQUEST_FOR_CHANGES_TICKET: '[TICKET] Clear request for changes ticket',
  SEARCH_REQUEST_FOR_CHANGES_ERROR: '[TICKET] Search request for changes error',
  GET_REQUEST_FOR_CHANGES_TICKET: '[TICKET] Get request for changes ticket',
  GET_REQUEST_FOR_CHANGES_TICKET_SUCCESS: '[TICKET] Get request for changes ticket success',
  GET_REQUEST_FOR_CHANGES_TICKET_APPROVALS: '[TICKET] Get request for changes ticket approvals',
  GET_REQUEST_FOR_CHANGES_TICKET_APPROVALS_SUCCESS: '[TICKET] Get request for changes ticket approvals success',
  // licenses
  CLEAR_LICENSES: '[TICKET] Clear licenses',
  GET_TICKET_LICENSES: '[TICKET] Get ticket licenses',
  GET_TICKET_LICENSES_SUCCESS: '[TICKET] get ticket licenses success',
  GET_LICENSES: '[TICKET] Get licenses',
  GET_LICENSES_SUCCESS: '[TICKET] Get licenses success',
  GET_REQUEST_FOR_CHANGES_TICKET_LICENSES: '[TICKET] Get request for changes ticket licenses',
  GET_REQUEST_FOR_CHANGES_TICKET_LICENSES_SUCCESS: '[TICKET] Get request for changes ticket licenses success',
};

export const GetTicketListEntryPoint = createAction(
  TicketActionTypes.GET_TICKET_LIST_ENTRY_POINT,
  props<{}>()
);
export const GetTicketListEntryPointSuccess = createAction(
  TicketActionTypes.GET_TICKET_LIST_ENTRY_POINT_SUCCESS,
  props<{ [TICKET_LIST_ENTRY_POINT]: string }>()
);
export const GetTicketListEntryPointError = createAction(
  TicketActionTypes.GET_TICKET_LIST_ENTRY_POINT_ERROR,
  props<{}>()
);

export const SearchTicketsAction = createAction(
  TicketActionTypes.SEARCH,
  props<{
    ticketFilters: TicketFilter[];
    ticketPagingConfig: ApiPagingConfig;
    ticketType: string[] | string;
  }>()
);

export const CancelSearchTickets = createAction(
  TicketActionTypes.CANCEL_SEARCH
);

export const GetUpdatesAvailable = createAction(
  TicketActionTypes.GET_UPDATES_AVAILABLE,
  props<{ updatesType: string }>()
);

export const GetUpdatesAvailableSuccess = createAction(
  TicketActionTypes.GET_UPDATES_AVAILABLE_SUCCESS,
  props<{
    updatesType: string;
    available: boolean;
  }>()
);

export const SearchChangeRecordsTicketsSuccessAction = createAction(
  TicketActionTypes.SEARCH_CHANGE_RECORDS_SUCCESS,
  props<{
    tickets: Ticket[];
    totalCount: string;
  }>()
);

export const ClearChangeRecordsTickets = createAction(
  TicketActionTypes.CLEAR_CHANGE_RECORDS_TICKETS
);

export const ClearTickets = createAction(TicketActionTypes.CLEAR_TICKETS);

export const SearchChangeRecordsTicketsErrorAction = createAction(
  TicketActionTypes.SEARCH_CHANGE_RECORDS_ERROR,
  props<{}>()
);

export const GetTicketSuccess = createAction(
  TicketActionTypes.GET_TICKET_SUCCESS,
  props<{
    ticket: Ticket;
    statuses: { [key: string]: TicketStatus };
    prioritys: { [key: string]: string };
  }>()
);

export const GetChangeRecordsTicket = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET,
  props<{
    ticket: any;
    topicType: string;
  }>()
);

export const GetTicket = createAction(
  TicketActionTypes.GET_TICKET,
  props<{
    id: string;
    topicType: string;
  }>()
);

export const ClearTicket = createAction(TicketActionTypes.CLEAR_TICKET);

export const GetChangeRecordsTicketSuccess = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_SUCCESS,
  props<{
    ticket: any;
    statuses: { [key: string]: TicketStatus };
    prioritys: { [key: string]: string };
  }>()
);

export const GetChangeTasksForChangeRecordsTicket = createAction(
  TicketActionTypes.GET_CHANGE_TASKS_FOR_CHANGE_RECORDS_TICKET,
  props<{
    id: string;
    dir: Array<string> | string;
    searchFields: Array<string> | string;
  }>()
);

export const GetChangeTasksForChangeRecordsTicketSuccess = createAction(
  TicketActionTypes.GET_CHANGE_TASKS_FOR_CHANGE_RECORDS_TICKET_SUCCESS,
  props<{
    changeTasks: any;
  }>()
);

export const GetChangeRecordsTicketAssessment = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_ASSESSMENT,
  props<{
    id: string;
  }>()
);

export const GetChangeRecordsTicketAssessmentSuccess = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_ASSESSMENT_SUCCESS,
  props<{
    assessment: any;
  }>()
);

export const GetChangeRecordsTicketPlanning = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_PLANNING,
  props<{
    id: string;
  }>()
);

export const GetChangeRecordsTicketPlanningSuccess = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_PLANNING_SUCCESS,
  props<{
    planning: any;
  }>()
);

export const GetChangeRecordsTicketScheduling = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_SCHEDULING,
  props<{
    id: string;
  }>()
);

export const GetChangeRecordsTicketSchedulingSuccess = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_SCHEDULING_SUCCESS,
  props<{
    scheduling: any;
  }>()
);

export const GetChangeRecordsTicketAffected = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_AFFECTED,
  props<{
    id: string;
    dir: Array<string> | string;
    searchFields: Array<string> | string;
  }>()
);

export const GetChangeRecordsTicketAffectedSuccess = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_AFFECTED_SUCCESS,
  props<{
    affected: any;
  }>()
);

export const GetChangeRecordsTicketImplementation = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_IMPLEMENTATION,
  props<{
    id: string;
  }>()
);

export const GetChangeRecordsTicketImplementationSuccess = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_IMPLEMENTATION_SUCCESS,
  props<{
    implementation: any;
  }>()
);

export const GetChangeRecordsTicketApprovals = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_APPROVALS,
  props<{
    id: string;
    dir: Array<string> | string;
    searchFields: Array<string> | string;
  }>()
);

export const GetTicketApprovals = createAction(
  TicketActionTypes.GET_TICKET_APPROVALS,
  props<{
    id: string;
  }>()
);

export const GetServiceRequestsTasks = createAction(
  TicketActionTypes.GET_SERVICE_REQUESTS_TASKS,
  props<{
    id: string;
  }>()
);

export const GetChangeRecordsTicketApprovalsSuccess = createAction(
  TicketActionTypes.GET_CHANGE_RECORDS_TICKET_APPROVALS_SUCCESS,
  props<{
    approvals: any;
  }>()
);

export const GetTicketApprovalsSuccess = createAction(
  TicketActionTypes.GET_TICKET_APPROVALS_SUCCESS,
  props<{
    approvals: any;
  }>()
);

export const GetPendingApprovals = createAction(
  TicketActionTypes.GET_APPROVALS,
  props<{
    paging: ApiPagingConfig;
  }>()
);

export const GetPendingApprovalsSuccess = createAction(
  TicketActionTypes.GET_APPROVALS_SUCCESS,
  props<{
    approvals: [];
    totalCount: string;
  }>()
);

export const GetTicketInteractions = createAction(
  TicketActionTypes.GET_TICKET_INTERACTIONS,
  props<{
    ticketId: string;
    paging: ApiPagingConfig;
  }>()
);

export const GetTicketInteractionsSuccess = createAction(
  TicketActionTypes.GET_TICKET_INTERACTIONS_SUCCESS,
  props<{
    interactions: IInteractionItem[];
    totalCount: string;
  }>()
);
export const ClearInteractions = createAction(
  TicketActionTypes.CLEAR_INTERACTIONS
);

export const PostTicketInteractions = createAction(
  TicketActionTypes.POST_TICKET_INTERACTION,
  props<{
    interaction: any;
    files?: IFile[];
  }>()
);

export const PostTicketInteractionsSuccess = createAction(
  TicketActionTypes.POST_TICKET_INTERACTION_SUCCESS,
  props<{
    interaction: IInteractionItem;
  }>()
);

export const PostTicketInteractionsError = createAction(
  TicketActionTypes.POST_TICKET_INTERACTION_ERROR,
  props<{
    error: IResponseMessage;
  }>()
);

export const ClearChangeRecordsTicket = createAction(
  TicketActionTypes.CLEAR_CHANGE_RECORDS_TICKET
);

export const ClearApprovals = createAction(TicketActionTypes.CLEAR_APPROVALS);

export const SearchTicketsSuccessAction = createAction(
  TicketActionTypes.SEARCH_SUCCESS,
  props<{
    tickets: Ticket[];
    totalCount: string;
  }>()
);

export const GetOrderItems = createAction(
  TicketActionTypes.GET_ORDER_ITEMS,
  props<{
    id: string;
  }>()
);

export const SetOrderItems = createAction(
  TicketActionTypes.SET_ORDER_ITEMS,
  props<{
    orders: any[];
  }>()
);

export const setOrdersLoadingStatus = createAction(
  TicketActionTypes.ORDERS_LOADING_STATUS,
  props<{
    isLoading: boolean;
  }>()
);

// RequestForChanges
export const SearchRequestForChangesTicketsSuccessAction = createAction(
  TicketActionTypes.SEARCH_REQUEST_FOR_CHANGES_SUCCESS,
  props<{
    tickets: Ticket[];
    totalCount: string;
  }>()
);

export const ClearRequestForChangesTickets = createAction(
  TicketActionTypes.CLEAR_REQUEST_FOR_CHANGES_TICKETS
);

export const SearchRequestForChangesTicketsErrorAction = createAction(
  TicketActionTypes.SEARCH_REQUEST_FOR_CHANGES_ERROR,
  props<{}>()
);


export const GetRequestForChangesTicket = createAction(
  TicketActionTypes.GET_REQUEST_FOR_CHANGES_TICKET,
  props<{
    ticket: any;
    topicType: string;
  }>()
);

export const GetRequestForChangesTicketSuccess = createAction(
  TicketActionTypes.GET_REQUEST_FOR_CHANGES_TICKET_SUCCESS,
  props<{
    ticket: any;
    statuses: { [key: string]: TicketStatus };
    prioritys: { [key: string]: string };
  }>()
);

export const GetRequestForChangesTicketApprovals = createAction(
  TicketActionTypes.GET_REQUEST_FOR_CHANGES_TICKET_APPROVALS,
  props<{
    id: string;
    dir: Array<string> | string;
    searchFields: Array<string> | string;
  }>()
);

export const GetRequestForChangesTicketApprovalsSuccess = createAction(
  TicketActionTypes.GET_REQUEST_FOR_CHANGES_TICKET_APPROVALS_SUCCESS,
  props<{
    approvals: any;
  }>()
);

export const ClearRequestForChangesTicket = createAction(
  TicketActionTypes.CLEAR_REQUEST_FOR_CHANGES_TICKET
);

// licenses
export const ClearLicenses = createAction(TicketActionTypes.CLEAR_LICENSES);
export const GetTicketLicenses = createAction(
  TicketActionTypes.GET_TICKET_LICENSES,
  props<{
    id: string;
  }>()
);

export const GetPendingLicenses = createAction(
  TicketActionTypes.GET_LICENSES,
  props<{
    paging: ApiPagingConfig;
  }>()
);

export const GetPendingLicensesSuccess = createAction(
  TicketActionTypes.GET_LICENSES_SUCCESS,
  props<{
    licenses: [];
    totalCount: string;
  }>()
);

export const GetTicketLicensesSuccess = createAction(
  TicketActionTypes.GET_LICENSES_SUCCESS,
  props<{
    licenses: [];
    totalCount: string;
  }>()
);
